const SERVICE = 'aion';
const LANG = 'ko-KR';
export const ALIAS = {
    ARTWORK: 'aion-artwork-list',
    SCREENSHOT: 'aion-screenshot-list',
    WALLPAPER: 'aion-wallpaper-list',
    DIGITALKIT: 'aion-digitalkit-list',
    CARTOON_HOME: 'cartoon-home',
    CHATLOG_TERMS: 'chatlog-terms',
    DOWNLOAD_CLIENT: 'download-client',
    BALANCELAB_BANNER: 'balancelab-banner',
    BALANCELAB_THUMBNAIL: 'balancelab-thumb',
    IMAGE_BANNER: 'image-banner',
    IMAGE_THUMBNAIL: 'image-thumb',
    IMAGE_CLASSIC_BANNER: 'image-classic-banner',
    IMAGE_CLASSIC_THUMBNAIL: 'image-classic-thumb',
    UPDATENODE_BANNER: 'updatenote-banner',
    GUIDE_LIVE_ELYOS: 'guide-live-elyos',
    GUIDE_LIVE_ASMODIAN: 'guide-live-asmodian',
    GUIDE_CLASSIC_ELYOS: 'guide-classic-elyos',
    GUIDE_CLASSIC_ASMODIAN: 'guide-classic-asmodian',
    PCBANG_NEWS: 'pcbang-news',
    SCHEDULE_LIVE: 'schedule-live',
    SCHEDULE_CLASSIC: 'schedule-classic',
    SCHEDULE_LIVE_TAG: 'schedule-live-tag',
    SCHEDULE_LIVE_NOTICE: 'schedule-live-notice',
    SCHEDULE_LIVE_DATA: 'schedule-live-data',
    SCHEDULE_LIVE_TABLE: 'schedule-live-table',
    SCHEDULE_LIVE_UPDATE: 'schedule-live-update',
    SCHEDULE_CLASSIC_TAG: 'schedule-classic-tag',
    SCHEDULE_CLASSIC_NOTICE: 'schedule-classic-notice',
    SCHEDULE_CLASSIC_DATA: 'schedule-classic-data',
    SCHEDULE_CLASSIC_TABLE: 'schedule-classic-table',
    SCHEDULE_CLASSIC_UPDATE: 'schedule-classic-update',
    MAIN_ADMIN_CONTENT: 'main-admin-content',
    MAIN_COMMUNITY_NEWS: 'main-community-news',
    MAIN_CUNAMARKET: 'main-cunamarket',
    MAIN_TIPNGUIDE_CARD: 'main-tipNguide-card',
    MAIN_TIPNGUIDE_LIST: 'main-tipNguide-list',
    MAIN_UPDATE_DEFAULT: 'main-update-default',
    MAIN_UPDATE_SPECIAL: 'main-update-special',
};

export const CONTI_URL = {
    CONTENT: '/conti/getContent?&alias={{alias}}&service={{service}}&lang={{lang}}',
    GROUP: '/conti/getContentGroup?groupAlias={{alias}}&service={{service}}',
    CONTENT_JSON: '/conti/getContentJsonData?alias={{alias}}&service={{service}}&lang={{lang}}',
    CONTENT_JSON_MAP: '/conti/getContentJsonDataMap?alias={{alias}}&service={{service}}&lang={{lang}}'
};

export const getContiApi = (contiUrl = CONTI_URL.CONTENT_JSON_MAP, apiDomain, alias) => {
    if(!contiUrl || !apiDomain || !alias) {
        console.error('conti api url을 생성할 수 없습니다.');
        return;
    }

    const replaceUrl = contiUrl.replace('{{alias}}', alias).replace('{{service}}', SERVICE).replace('{{lang}}', LANG);

    return `${apiDomain}${replaceUrl}`;
};